
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class BookingSetting extends Vue {
  corporateConfig = {
    bookingNotifyBooker: {},
    bookingNotifyCustomer: {},
    bookingNotifyDriver: {},
  };
  url = "/api/corp/config/get";
  name = "";
  country = "";
  year = "";
  filterUrl = "";
  page = 1;
  on = null;
  date = null;
  get loading() {
    return common.loading;
  }

  async save() {
    try {
      common.setLoading(true);
      this.corporateConfig = await doPost(
        "/api/corp/config/booking/save",
        this.corporateConfig
      );
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }

  async mounted() {
    try {
      this.corporateConfig = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
  }

  async showPage(page) {
    this.page = page;
    this.corporateConfig = await doGet(
      this.url + this.filterUrl + "&page=" + page
    );
    common.setLoading(false);
  }
}
